import moment from 'moment';
import 'moment-timezone';
import Utils from '@/services/utils.js';
import {useDvFlagAccess} from "../../../services/featureFlag";

const iconTempWatchman = require('@/assets/img/iconTemporaryWatchman.svg')
const iconIdNoPicture = require('@/assets/img/user-no-img.png')

export default {

    Datis(data) {
        var now = moment()

        var transformedData = {
            headers: [
                window.V.$i18n.t('home.widgets.list.dati'),
                window.V.$i18n.t('home.widgets.list.session'),
                window.V.$i18n.t('home.widgets.list.lastCommunication'),
            ],
            data: [],
        }

        if (data.length == 0 || !useDvFlagAccess("beepiz-dashboard-live-session-can:read")) {
            transformedData.data.push({
                className: 'no-item',
                cellsMarkup: [
                    window.V.$i18n.t('home.widgets.list.nodati')
                ]
            });
            return transformedData;
        }

        for (var i = 0; i < data.length; i++) {
            let itemData = data[i];

            if (itemData.dati) {
                let firstCol = ''
                let secondCol = ''
                let thirdCol = ''
                let rowType = 'dati'


                if (itemData.identification) {
                    firstCol = '<img class="widget-list-img-identification ' + '" src="' + (itemData.identification.picture ? itemData.identification.picture : iconIdNoPicture) + '" />' + '<span class="widget-list-first-label">' + itemData.identification.name + '</span><br><span class="widget-list-second-label">' + itemData.dati.name + '</span>'
                } else {
                    //WIP ADD AVATARS // Oh yeah ?
                    firstCol = '<span class="widget-list-first-label" style="display: flex; margin-left: -30px; width: 180%">' + itemData.dati.name + '</span>'
                }

                if (itemData.dati.device_manufacturer != 'box') {
                    secondCol = itemData.datiSession_id ? window.V.$i18n.t('home.widgets.list.sessionstart') + '<br>' + Utils.momentLocalised(itemData.datiSession_start_at).fromNow() : '';
                }

                itemData.spClass = ""
                if (itemData.alerts && itemData.alerts.length > 0) {
                    itemData.spClass = itemData.spClass + " alert-animate "
                }
                if (itemData.offline_zone_deadline) {
                    itemData.spClass = itemData.spClass + " offline-zone"
                }
                if (itemData.lost_com_at != null) {
                    secondCol = window.V.$i18n.t('home.widgets.list.lostcom') + ' ' + Utils.momentLocalised(itemData.activity_at).fromNow();
                    itemData.spClass = itemData.spClass + " type-lostcom "
                    rowType = 'lostCom'
                }
                if (itemData && itemData.activity_at.date) {
                    thirdCol = '<div>' + Utils.momentLocalised(itemData.activity_at).format('HH:mm') + '<br/>' + Utils.momentLocalised(itemData.activity_at).format('DD/MM/YYYY') + '</div>'
                }

                transformedData.data.push({
                    className: 'dati-row ' + itemData.spClass, type: 'dati', key: itemData.id,
                    cellsMarkup: [
                        firstCol,
                        secondCol,
                        thirdCol,
                    ],
                    cellsLink: [
                        useDvFlagAccess("beepiz-licence-can:update") ? '/devices/' + itemData.id : null,
                        null,
                        null
                    ],
                    rowType: rowType,
                    rowData: itemData,
                });

                if (data[i].alerts && data[i].alerts.length > 0) {
                    for (var j = data[i].alerts.length - 1; j >= 0; j--) {
                        if (itemData.alerts[j].ack_at === null) {
                            let alertInfoIcon = ''
                            const accessoryIcon = Utils.getIconAccessory(itemData.alerts[j].event_type_icon)
                            if (accessoryIcon !== null) {
                                alertInfoIcon = '<span class="widget-list-icon-type-event">' + accessoryIcon + '</span>'
                            } else {
                                alertInfoIcon = '<i class="widget-list-icon-type-event ' + itemData.alerts[j].event_type_icon + '"></i>';
                            }
                            var alertInfo = '<div class="dati-alert-info text-truncate pl-[12px]">' +
                                alertInfoIcon +
                                '<strong>' + itemData.alerts[j].event_type_label + '</strong> ' + (itemData.alerts[j].event_type == 1 ? Utils.t('home.widgets.detected2') : Utils.t('home.widgets.detected')) + ' ' + Utils.momentLocalised(itemData.alerts[j].event_at).fromNow() +
                                '<span class="time">(' + Utils.momentLocalised(itemData.alerts[j].event_at).format('HH:mm') + ')</span>'

                            if (itemData.bpm_value) {
                                alertInfo += '<span class="bpm"><i class="fa fa-heartbeat" aria-hidden="true"></i> ' + itemData.bpm_value + ' BPM</span>'
                            }

                            alertInfo += '</div>'

                            transformedData.data.push({
                                className: 'dati-row dati-alert-info ' + itemData.spClass,
                                type: 'dati',
                                key: itemData.id,
                                cellsMarkup: [
                                    alertInfo
                                ],
                                cellsLink: [
                                    null,
                                    null,
                                    null
                                ],
                                rowType: 'alert',
                                rowData: itemData.alerts[j],
                            });

                        }
                    }
                }

                if (itemData.temporary_watchmen && itemData.temporary_watchmen.length > 0) {
                    itemData.temporary_watchmen.filter(tw => tw.status === "waiting" || tw.status === "accepted").forEach(tempWatchman => {
                        transformedData.data.push({
                            className: 'dati-row dati-offline-info ' + itemData.spClass,
                            type: 'dati',
                            key: itemData.id,
                            cellsMarkup: [
                                `<div class="d-flex align-items-center text-xs py-1" style="line-height: 1.25;">
                                    <span class="widget-list-icon-type-event">${iconTempWatchman}</span>
                                    <strong>${Utils.t('home.widgets.states.temporaryWatchman.title')}</strong>
                                </div>`,
                                `<div class="d-flex align-items-center text-xs py-1 px-3" style="line-height: 1.25;">
                                    <div>
                                        ${tempWatchman.status === "accepted" ? '<i class="fa fa-check text-success" aria-hidden="true"></i> ' : ''}<strong>${tempWatchman.name}</strong><br/>
                                        <span class="text-mono text-blackalpha-600">${tempWatchman.num_phone}</span>
                                    </div>
                                </div>`,
                                `<div class="d-flex align-items-center text-xs py-1 px-3" style="line-height: 1.25;">
                                    <div>
                                        ${Utils.t('home.widgets.states.temporaryWatchman.ending')}<br/>
                                        ${tempWatchman.time_hours == -1 ?
                                    Utils.t('home.widgets.states.temporaryWatchman.session_end') :
                                    Utils.momentLocalised(tempWatchman.time_end).format('HH:mm')
                                }
                                    </div>
                                </div>`
                            ],
                            cellsLink: [
                                null,
                                null,
                                null
                            ],
                            rowType: 'temporaryWatchman',
                            rowData: tempWatchman,
                        });
                    });

                }

                for (let accessory in itemData.accessories) {
                    let accessoryInfo = Utils.getAccessoryInformation(accessory)
                    let accessoryData = itemData.accessories[accessory]

                    firstCol = ''
                    secondCol = '<div></div>'
                    thirdCol = '<div></div>'

                    firstCol = '<span class="widget-list-icon-type-event size-6 do-svg-full">' + accessoryInfo.logo + '</span> <strong>' + accessoryInfo.label + '</strong>'
                    if (accessoryData['current_battery_level'] != null) {
                        secondCol = '<div class="d-flex align-items-center text-xs py-1 px-3 line-height-tight"><div>' + window.V.$i18n.t('device.battery') + ' ' + accessoryData['current_battery_level'] + '%<div></div>'
                    }
                    if (accessoryData['in_tension_max']) {
                        thirdCol = '<div class="d-flex align-items-center text-xs py-1 px-3 line-height-tight ' + (itemData.spClass === "" ? 'text-red-600' : null) + '">' +
                            '<span class="fa fa-bolt pr-1"></span> 3 (max)' +
                            '</div>'
                    }

                    transformedData.data.push({
                        className: 'dati-row dati-offline-info ' + itemData.spClass,
                        type: 'accessories',
                        key: itemData.id,
                        cellsMarkup: [
                            firstCol, secondCol, thirdCol
                        ],
                        cellsLink: [
                            null,
                            null,
                            null
                        ],
                        rowType: 'accessories',
                    });
                }

                if (itemData.offline_zone_deadline) {
                    itemData.spClass = (!itemData.attachment) ? 'dati-row dati-offline-info text-xs bottom-border-yellow' + itemData.spClass : 'dati-row dati-offline-info text-xs ' + itemData.spClass
                    transformedData.data.push({
                        className: itemData.spClass,
                        type: 'dati',
                        key: itemData.id,
                        cellsMarkup: [
                            '<div class="offline-info"><i class="widget-list-icon-offline beepiz-offline-zone-in"></i>' + Utils.t('home.widgets.states.offlineZone') + ' ' + Utils.readableDuration(Utils.momentLocalised(itemData.offline_zone_deadline).diff(now, 'seconds')) + '</div>'
                        ],
                        cellsLink: [
                            null,
                            null,
                            null
                        ],
                        rowType: 'offlineZone',
                        rowData: itemData,
                    });
                }

                if (itemData.attachment) {
                    this.filteredVocalAttachment(itemData.attachment).forEach(currentSound => {
                        transformedData.data.push({
                            className: 'dati-row text-xs offline-zone bottom-border-yellow',
                            type: 'dati',
                            key: currentSound.hash,
                            cellsMarkup: [
                                null,
                                null,
                                null
                            ],
                            cellsLink: [
                                null,
                                null,
                                null
                            ],
                            rowType: 'vocal',
                            rowData: itemData,
                        })
                    });

                }
            }

        }

        return transformedData;
    },
    filteredVocalAttachment(listAttachment) {
        return listAttachment.filter((oneAttachment) => {
            return oneAttachment.ext === "mp3";
        });
    },
    Events(data) {

        let transformedData = {
            headers: [
                window.V.$i18n.t('home.widgets.list.event'),
                window.V.$i18n.t('home.widgets.list.dati')
            ],
            data: [],
            filters: [
                'eventCategory'
            ],
        }

        if (data.length == 0) {
            transformedData.data.push({
                className: 'event-row no-item',
                cellsMarkup: [
                    window.V.$i18n.t('home.widgets.list.noevent')
                ]
            });

            return transformedData;
        }

        for (var i = 0; i < data.length; i++) {
            let itemData = data[i];

            let firstCol = '';
            let secondCol = '';

            const end = Utils.momentLocalised(itemData.eventAt);
            const start = Utils.momentLocalised(itemData.eventAt).subtract(8, 'hours');
            const period = start.format('YYYY-MM-DD HH:mm') + '_' + end.format('YYYY-MM-DD HH:mm');

            const accessoryIcon = Utils.getIconAccessory(itemData.icon)
            if
            (
                itemData.type === "77" ||
                itemData.type === "78" ||
                itemData.type === "79" ||
                itemData.type === "80" ||
                itemData.type === "81"
            ) {
                firstCol = '<span class=""><span class="widget-list-icon-type-event">' + iconTempWatchman + '</span>' + itemData.name;

            } else if (accessoryIcon !== null) {
                firstCol = '<span class=""><span class="widget-list-icon-type-event">' + accessoryIcon + '</span>' + itemData.name;
            } else {
                firstCol = '<span class=""><i class="widget-list-icon-type-event ' + itemData.icon + '"></i>' + itemData.name;
            }
            if (itemData.alertId != null) {
                firstCol += '<br><span>N° ' + Utils.alertNumberFormated(itemData.alertId) + '</span>'
            }
            firstCol += '</span><br>';

            if (itemData.actionPoints && itemData.actionPoints.length > 0) {
                firstCol += '<span class="widget-list-actionpoint">' + itemData.actionPoints[0].name + '</span><br>';
            }

            if (useDvFlagAccess("beepiz-report-can:read")) {
                if (itemData.type == "48") {
                    //Batterie AP
                    firstCol += '<a href="#/reports/actionpoint" onclick="event.stopPropagation()"><span class="date" title="' + Utils.t('home.widgets.reportAP') + '">' + Utils.momentLocalised(itemData.eventAt).format(Utils.t('datetime.dateHourMinutes')) + '</span></a>'
                } else {
                    firstCol += '<a href="#/reports/activity/dati-' + itemData.dati.id + '/' + period + '" onclick="event.stopPropagation()"><span class="date" title="' + Utils.t('home.widgets.report') + '">' + Utils.momentLocalised(itemData.eventAt).format(Utils.t('datetime.dateHourMinutes')) + '</span></a>'
                }
            } else {
                firstCol += '<span class="date">' + Utils.momentLocalised(itemData.eventAt).format(Utils.t('datetime.dateHourMinutes')) + '</span>'
            }

            if (itemData.identification) {
                secondCol = '<img class="widget-list-img-identification ' + (itemData.alert === true ? 'alert-animate' : null) + '" src="' + (itemData.identification.picture ? itemData.identification.picture : iconIdNoPicture) + '" />' +
                    '<span class="widget-list-first-label" style="display: flex; margin-left: 30px; margin-bottom: -20px">' + itemData.identification.name + '</span><br>' +
                    '<span class="widget-list-second-label" style="display: flex; margin-left: 30px">' + itemData.dati.name + '</span>'
            } else {
                secondCol = '<div style="display: flex; margin-left: -20px"><span class="widget-list-first-label">' + itemData.dati.name + '</span></div>';
            }

            var alertClass = '';
            if (itemData.alertId != null && itemData.alertAcked == null) {
                alertClass = ' animate';
            }

            if (itemData.type == "49") {
                alertClass = ' alert-update'
            }

            transformedData.data.push({
                className: 'event-row severity-' + itemData.eventCategory + alertClass,
                type: 'event',
                key: itemData.id,
                alertAcked: itemData.alertAcked,
                alertId: itemData.alertId,
                alertUrl: itemData.alertUrl,
                'eventCategory': itemData.eventCategory,
                cellsMarkup: [
                    firstCol,
                    secondCol,
                ],
                cellsLink: [
                    null,
                    useDvFlagAccess("beepiz-licence-can:update") ? '/devices/' + itemData.dati.id : null
                ]
            });

        }

        return transformedData;
    }

}
